import {
    Component,
    Input,
    OnInit,
    ViewChild,
    ElementRef, EventEmitter, Output
} from '@angular/core';
import { SafeHtml, DomSanitizer } from '@angular/platform-browser';
import { AbstractPageBuilderService } from '../../services/abstract-page-builder.service';

@Component({
    selector: 'agpr-twig',
    templateUrl: 'twig-renderer.component.html',
    styleUrls: ['./twig-renderer.component.scss'],
    standalone: false
})
export class TwigRendererComponent implements OnInit {

    @Input() id: string;
    @Input() set twigTemplate(value: string) {
        this._twigTemplate = value;

        if (this.hasInitted) {
            this.render();
        }
    }
    @Input() set data(value: any) {
        this._data = value || {};

        if (this.hasInitted) {
            this.render();
        }
    }
    // Prevents rendered links from receiving focus/ being activated via keyboard
    @Input() preventChildFocus: boolean = false;
    @Input() generateOnSend: boolean;
    @Input() set renderedHtml(value: string) {
        this._renderedHtml = value;

        if (this.hasInitted) {
            this.render();
        }
    }

    @ViewChild('shadow', { static: true }) shadowContainer: ElementRef;

    @Output() renderedOutput: EventEmitter<string> = new EventEmitter<string>();

    private shadowRoot: ShadowRoot;
    private _renderedHtml: string;
    private _twigTemplate: string;
    _data: any = {};
    renderedBackup: SafeHtml;

    hasInitted: boolean = false;

    constructor(
        public domSanitizer: DomSanitizer,
        public pageBuilderService: AbstractPageBuilderService
    ) {
    }

    ngOnInit() {
        // Use shadow dom if it's available on the current browser
        // attachShadow function won't be available on browsers that don't support it
        if (this.shadowContainer.nativeElement.attachShadow) {

            // Remove the backup which can be rendered first via ngOnChanges
            this.renderedBackup = null;

            // Create the shadow root for style isolation
            this.shadowRoot = this.shadowContainer.nativeElement.attachShadow({mode: 'open'});
        }
        this.render();
        this.hasInitted = true;
    }

    /**
     * Renders the twig template and data into the shadow container.
     */
    render() {
        let output: string;

        if (this._renderedHtml) {
            output = this._renderedHtml;
        } else if (this._twigTemplate) {
            output = this.pageBuilderService.renderTemplate(this._twigTemplate, this._data);
        } else {
            return;
        }

        if (this.shadowRoot) {
            this.shadowRoot.innerHTML = output;
        } else {
            this.renderedBackup = this.domSanitizer.bypassSecurityTrustHtml(output);
        }

        const style = document.createElement('style');
        style.innerHTML = '.insightText > p, .insightText > ul { margin-top: 0px; margin-bottom: 0px; }';
        style.innerHTML += ' .insightText > p:last-of-type { margin-bottom: 20px; }';
        this.shadowRoot?.appendChild(style);

        this.renderedOutput.emit(output);
    }
}
